import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { Button } from '@components/Button';
import { CloudImage } from '@components/CloudImage';
import { themeSpace } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { TOP_BANNER_HEIGHT } from '@layout';

export const StyledBox = styled(Box)`
  text-align: center;
`;

export const HeroTextWrapper = styled(Box)`
  padding-top: calc(${themeSpace(10)} + ${TOP_BANNER_HEIGHT}px);
  padding-bottom: ${themeSpace(7)};
`;

export const StyledButton = styled(Button)`
  position: relative;
  z-index: 1;
`;

export const StyledTextPairing = styled(TextPairing)`
  align-items: center;
  .text-pairing-title {
    text-align: center;
    max-width: 260px;
    margin-bottom: ${themeSpace(7)};
  }
  .text-pairing-body {
    max-width: 360px;
    margin: 0 ${themeSpace(5)};
  }
`;

export const HeroBox = styled(Box)`
  height: 100vw;
  @media (min-width: 768px) {
    height: 120vw;
  }
`;

export const HeroCloudImage = styled(CloudImage)`
  position: absolute;
  top: 400px;
  width: 100%;
`;

export const LeftBox = styled(Box)`
  position: absolute;
  left: 0;
`;

export const RightBox = styled(Box)`
  position: absolute;
  right: 0;
`;

export const RightCurlBox = styled(RightBox)`
  @media (min-width: 768px) {
    right: 117px;
  }
`;

export const SideCloudImage = styled(CloudImage)<{ reswidth: number }>`
  height: 100%;
  @media (min-width: 768px) {
    width: ${({ reswidth }) => reswidth}%;
    margin-top: ${themeSpace(5)};
  }
`;

export const YellowCircleCloudImage = styled(CloudImage)`
  width: 32vw;
`;

export const StyledFlex = styled(Flex)`
  height: 100vw;
  position: relative;
`;

export const IconCloudImage = styled(CloudImage)`
  @media (min-width: 768px) {
    margin-top: ${themeSpace(10)};
  }
`;

export const StyledText = styled(Text)`
  width: fit-content;
  @media (min-width: 768px) {
    font-size: 40px;
    line-height: 48px;
  }
`;

export const StyledTextCollect = styled(StyledText)`
  width: fit-content;
`;

export const StyledCloudImage = styled(CloudImage)<{ top: number; left: number }>`
  position: absolute;
  top: ${({ top }) => top}%;
  left: ${({ left }) => left}%;
  z-index: 1;
`;
